const {
  evaluateSource
} = require('../lib/evaluateSource');

/**
  * @function evalute
  * @returns an option selection corresponding to the current user.
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const infoSource = {
    type: 'clientInfoBehavior'
  };
  const {
    userID,
    firstName,
    lastName
  } = await evaluateSource(infoSource, content, parentContentPath, transientContext, nativeFunctions);
  if (userID === undefined) {
    return undefined;
  }
  return {
    [userID]: {
      title: [firstName, lastName].join(' ')
    }
  };
};
module.exports = {
  evaluate
};